module.exports = __webpack_public_path__ + "img/Thief.24e9108d.png";